import React from 'react';

import {
	AcidDamageIcon,
	BludgeoningDamageIcon,
	ColdDamageIcon,
	FireDamageIcon,
	FlashIcon,
	ForceDamageIcon,
	NecroticDamageIcon,
	PiercingDamageIcon,
	PoisonDamageIcon,
	PsychicDamageIcon,
	RadiantDamageIcon,
	SlashingDamageIcon,
	ThunderDamageIcon,
} from '@kit';

import {damageTypeLabel} from '../model/labels';

import css from './sheet.module.css';

const DAMAGE_TYPES: Record<string, {Icon: React.FC<{size?: 20}>; title: string}> = {
	acid: {Icon: AcidDamageIcon, title: 'Урон кислотой'},
	bludgeoning: {Icon: BludgeoningDamageIcon, title: 'Дробящий урон'},
	cold: {Icon: ColdDamageIcon, title: 'Урон холодом'},
	fire: {Icon: FireDamageIcon, title: 'Урон огнём'},
	force: {Icon: ForceDamageIcon, title: 'Урон силой'},
	lightning: {Icon: FlashIcon, title: 'Урон молнией'},
	necrotic: {Icon: NecroticDamageIcon, title: 'Некротический урон'},
	piercing: {Icon: PiercingDamageIcon, title: 'Колющий урон'},
	poison: {Icon: PoisonDamageIcon, title: 'Урон ядом'},
	psychic: {Icon: PsychicDamageIcon, title: 'Психический урон'},
	radiant: {Icon: RadiantDamageIcon, title: 'Лучистый урон'},
	slashing: {Icon: SlashingDamageIcon, title: 'Режущий урон'},
	thunder: {Icon: ThunderDamageIcon, title: 'Урон громом'},
};

/** вид урона значком; название — во всплывающей подсказке: «Некротический урон» */
export const DamageTypeIcon: React.FC<{type: string}> = ({type}) => {
	const known = DAMAGE_TYPES[type.toLowerCase()];
	if (!known) return <span>{damageTypeLabel(type).toLowerCase()}</span>;
	const {Icon, title} = known;
	return (
		<span className={css.damageTypeIcon} title={title} role="img" aria-label={title}>
			<Icon size={20} />
		</span>
	);
};

/** несколько видов урона: «огонь или холод» значками */
export const DamageTypeIcons: React.FC<{types: string[]}> = ({types}) => (
	<>
		{types.map((type, index) => (
			<React.Fragment key={type}>
				{index > 0 && <span className={css.muted}>/</span>}
				<DamageTypeIcon type={type} />
			</React.Fragment>
		))}
	</>
);
